/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationResponseDto } from '../models/NotificationResponseDto';
import type { SendNotificationDto } from '../models/SendNotificationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationsService {
    /**
     * List notifications for current user
     * Returns a paginated list of notifications for the authenticated user, ordered by most recent.
     * @param page Page number (default: 1)
     * @param pageSize Items per page (default: 20)
     * @returns any Notifications fetched successfully
     * @throws ApiError
     */
    public static notificationsControllerListNotificationsV1(
        page?: number,
        pageSize?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/notifications',
            query: {
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Send a notification to a user (admin/internal)
     * Directly creates a notification record for a target user. Intended for admin use or internal tooling — normal delivery goes through the queue.
     * @param userId Target user UUID
     * @param requestBody
     * @returns NotificationResponseDto Notification sent successfully
     * @throws ApiError
     */
    public static notificationsControllerSendNotificationV1(
        userId: string,
        requestBody: SendNotificationDto,
    ): CancelablePromise<NotificationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/notifications',
            query: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request body`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get unread notification count
     * Returns the count of unread notifications for the current user. Use this to display the badge on the bell icon.
     * @returns any Unread count fetched successfully
     * @throws ApiError
     */
    public static notificationsControllerGetUnreadCountV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/notifications/unread-count',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Mark a notification as read
     * Marks a single notification as read and sets readAt timestamp. Only the owning user can mark their own notifications.
     * @param id Notification UUID
     * @returns NotificationResponseDto Notification marked as read successfully
     * @throws ApiError
     */
    public static notificationsControllerMarkAsReadV1(
        id: string,
    ): CancelablePromise<NotificationResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/notifications/{id}/read',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Notification not found`,
            },
        });
    }
    /**
     * Mark all notifications as read
     * Marks every unread notification for the current user as read in a single operation.
     * @returns any All notifications marked as read successfully
     * @throws ApiError
     */
    public static notificationsControllerMarkAllAsReadV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/notifications/read-all',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
